import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, AlertController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import * as moment from 'moment';
import { CalendarPage } from '../../calendar/calendar';


@Component({
  selector: 'page-popupaddvehicle',
  templateUrl: 'popupaddvehicle.html',
})
export class PopupaddvehiclePage {

  DriverId = ''
  codeInventory = ''


  _startDate: any = new Date()
  _startDateStr: any = moment().format('DD-MM-YYYY')
  _startDateYMD: any = moment().format('YYYY-MM-DD')

  _endDate: any = new Date()
  _endDateStr: any = moment().format('DD-MM-YYYY')
  _endDateYMD: any = moment().format('YYYY-MM-DD')

  // startdate: any = moment().format('YYYY-MM-DD')
  // enddate: any = moment().format('YYYY-MM-DD')
  radioVehicles: any;

  obj: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public alertCtrl: AlertController, public modalCtrl: ModalController) {
    if (this.gn.user.ClientId == 711 || this.gn.user.ClientId == 357) {
      this.codeInventory = this.dic.l["Inventarenbroj"]
    }
    else {
      this.codeInventory = this.dic.l["code"]
    }
    this.DriverId = navParams.get('driverid')
    this._startDateStr = moment(this._startDate).format('DD-MM-YYYY')
    this._endDateStr = moment(this._startDate).format('DD-MM-YYYY')
    this.obj = navParams.get('obj');
    if (this.obj != -1) {
      this.radioVehicles = this.obj.vehicleid;
      this._startDateStr = this.obj.begining
      this._endDateStr = this.obj.ending



    }

  }

  ionViewDidLoad() {

  }


  openDatePopup(_ev, _se) {
    var _that = this;
    var tmpDt = this._startDate;
    if (_se == 'e') { tmpDt = this._endDate }

    let popover = this.popoverCtrl.create(CalendarPage, {
      d: tmpDt, cb: function (d) {
        if (_se == 's') {
          _that._startDate = d;
          _that._startDateYMD = moment(_that._startDate).format('YYYY-MM-DD')
          _that._startDateStr = moment(_that._startDate).format('DD-MM-YYYY')
        }
        else {
          _that._endDate = d;
          _that._endDateYMD = moment(_that._endDate).format('YYYY-MM-DD')
          _that._endDateStr = moment(_that._endDate).format('DD-MM-YYYY')
        }
      }
    })
    popover.present({ ev: _ev });
  }


  Editit() {
    var _that = this

    var _dat = {

      permid: this.gn.crypt(this.obj.id),
      driverid: this.gn.crypt(this.DriverId),
      startdate: this.gn.crypt(this._startDateYMD),
      enddate: this.gn.crypt(this._endDateYMD),
      vehicleid: this.gn.crypt(this.radioVehicles)

    }
    this.gn._Post('/api/gn/updatedrivervehicledate', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
    })
  }


  Saveit() {
    var _that = this

    var _dat = {
      driverid: this.gn.crypt(this.DriverId),
      startdate: this.gn.crypt(this._startDateYMD),
      enddate: this.gn.crypt(this._endDateYMD),
      vehicleid: this.gn.crypt(this.radioVehicles),
      cid: this.gn.crypt(this.gn.user.ClientId)

    }
    this.gn._Post('/api/gn/setdrivervehicledate', _dat, function (_data) {
      var _cb = _that.navParams.get('cb')
      _cb()
      _that.navCtrl.pop()
    })

  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/driversettings/popupaddvehicle.ts